<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="text-right">
        <ExportButton
          :url="$root.$data.server_base + '/api/service_provider_requirements_export.php'"
          :filename="exportFilename"
          button-class="btn btn-default btn-sm"
          :service_provider_id="$route.params.service_provider_id"
        >
          <DocumentIcon :url="exportFilename" /> Exporter Format Excel
        </ExportButton>
      </div>
      
      <div class="table-responsive">
      <table class="table table-hover mb-none clickable-table za-exigence">
        <thead>
          <tr>
            <th colspan="2">Section</th>
            <th>Statut de l'exigence</th>
            <th>Appréciation</th>
            <th colspan="2"></th>
          </tr>
        </thead>
        <tbody>

        <tr v-for="(requirement, index) in requirements41" v-on:click="exigenceDetail(requirement.num)" :key="requirement.num">
          <td v-if="index==0" :rowspan="requirements41.length">4.1</td>
          <td style="padding-left:10px"><nobr>{{requirement.num}} - {{requirement.name}}</nobr></td>
          <td><em class="fas fa-square-full" :style="colorForStatus(requirement.status_id)"></em>&nbsp;&nbsp;{{requirement.status}}</td>
          <td><em class="fas fa-square-full" :style="colorForAppreciation(requirement.appreciation_id)"></em>&nbsp;&nbsp;{{requirement.appreciation}}</td>
          <td></td>
        </tr>
        <tr v-for="(requirement, index) in requirements42" v-on:click="exigenceDetail(requirement.num)" :key="requirement.num">
          <td v-if="index==0" :rowspan="requirements42.length">4.2</td>
          <td style="padding-left:10px"><nobr>{{requirement.num}} - {{requirement.name}}</nobr></td>
          <td><em class="fas fa-square-full" :style="colorForStatus(requirement.status_id)"></em>&nbsp;&nbsp;{{requirement.status}}</td>
          <td><em class="fas fa-square-full" :style="colorForAppreciation(requirement.appreciation_id)"></em>&nbsp;&nbsp;{{requirement.appreciation}}</td>
          <td></td>
        </tr>
        <tr v-for="(requirement,index) in requirements43" v-on:click="exigenceDetail(requirement.num)" :key="requirement.num">
          <td v-if="index==0" :rowspan="requirements43.length">4.3</td>
          <td style="padding-left:10px"><nobr>{{requirement.num}} - {{requirement.name}}</nobr></td>
          <td><em class="fas fa-square-full" :style="colorForStatus(requirement.status_id)"></em>&nbsp;&nbsp;{{requirement.status}}</td>
          <td><em class="fas fa-square-full" :style="colorForAppreciation(requirement.appreciation_id)"></em>&nbsp;&nbsp;{{requirement.appreciation}}</td>
          <td></td>
        </tr>
        <tr v-for="(requirement,index) in requirements44" v-on:click="exigenceDetail(requirement.num)" :key="requirement.num">
          <td v-if="index==0" :rowspan="requirements44.length">4.4</td>
          <td style="padding-left:10px"><nobr>{{requirement.num}} - {{requirement.name}}</nobr></td>
          <td><em class="fas fa-square-full" :style="colorForStatus(requirement.status_id)"></em>&nbsp;&nbsp;{{requirement.status}}</td>
          <td><em class="fas fa-square-full" :style="colorForAppreciation(requirement.appreciation_id)"></em>&nbsp;&nbsp;{{requirement.appreciation}}</td>
          <td></td>
        </tr>
        <tr v-for="(requirement,index) in requirements45" v-on:click="exigenceDetail(requirement.num)" :key="requirement.num">
          <td v-if="index==0" :rowspan="requirements45.length">4.5</td>
          <td style="padding-left:10px"><nobr>{{requirement.num}} - {{requirement.name}}</nobr></td>
          <td><em class="fas fa-square-full" :style="colorForStatus(requirement.status_id)"></em>&nbsp;&nbsp;{{requirement.status}}</td>
          <td><em class="fas fa-square-full" :style="colorForAppreciation(requirement.appreciation_id)"></em>&nbsp;&nbsp;{{requirement.appreciation}}</td>
          <td></td>
        </tr>
        </tbody>
      </table>
      </div>
    </div>

  </div>
</template>

<style>
table.za-exigence > tbody > tr > td {
  padding: 4px;
  /* font-size: 90%; */
}
</style>

<script>

import {requirementStatusColor, requirementAppreciationColor} from '@/assets/za_libs/colors.js';
import ExportButton from '@/components/ExportButton.vue';
import DocumentIcon from '@/components/DocumentIcon.vue';

import axios from 'axios';

export default {
  components: {
    ExportButton,
    DocumentIcon
  },
  data: function() {return {
    //service_provider_id:'',
    serviceprovider:{},
    requirements41:{},
    requirements42:{},
    requirements43:{},
    requirements44:{},
    requirements45:{},
  }},

  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_requirements.php',
          { params: {service_provider_id: this.$route.params.service_provider_id}})
        .then(response => (
          this.serviceprovider = response.data.serviceprovider,
          this.requirements41 = response.data.requirements41,
          this.requirements42 = response.data.requirements42,
          this.requirements43 = response.data.requirements43,
          this.requirements44 = response.data.requirements44,
          this.requirements45 = response.data.requirements45))
    },
    
    exigenceDetail: function(num)
    {
      this.$router.push({name:'exigenceDetail', params: {
        service_provider_id: this.$route.params.service_provider_id,
        requirement_num: num}});

    },

    colorForStatus(status_id) {
      return requirementStatusColor(status_id);
    },
    
    colorForAppreciation(appreciation_id) {
      return requirementAppreciationColor(appreciation_id);
    }

  },
  computed: {
    exportFilename() {
      return `exigences-fournisseur-no${this.$route.params.service_provider_id}-${this.moment().format('YYYY-MM-DD')}.xlsx`
    }
  },
  mounted () {
    //this.service_provider_id=this.$route.params.service_provider_id;
    this.refresh();
  }
}
</script>
